define([], function () {
  return  {
  "About": "About",
  "Center": "Center",
  "Left": "Left",
  "Right": "Right",
  "unable_to_parse_querystring": "The URL cannot be parsed. Please check the URL parameter 'queryString'.",
  "propertycategory_advanced": "Advanced",
  "All": "All",
  "Cancel": "Cancel",
  "not_now": "Remind me later",
  "deactivate_notification": "No thanks",
  "client_clear": "Reset",
  "client_search_clear": "Clear",
  "client_resultset_About": "About",
  "client_sidepane_refinements_label": "Refinement",
  "client_toolbar_support_label": "Support",
  "client_toolbar_help_label": "Help",
  "predefined_order": "Custom order<br><small>List of comma separated filter values, e.g. pdf,doc</small>",
  "order_direction": "Sort order",
  "client_toolbar_sortingalgorithm_label": "Sort by",
  "client_toolbar_summarize_by_label": "Summarize by",
  "sort_descending": "Descending",
  "sort_ascending": "Ascending",
  "client_headsup_feedback_button": "Feedback",
  "Copy": "Copy",
  "created": "Created",
  "Error": "Error",
  "ok": "OK",
  "location": "Location",
  "None": "None",
  "Open": "Open",
  "product_label": "Mindbreeze",
  "title": "Title",
  "editor_inherit_user_constraints_from_application": "Apply user restrictions to main search",
  "editor_inherit_source_context_constraints_from_application": "Apply application restrictions to main search",
  "editor_inherit_user_constraints_from_main_application": "Inherit Parent User Constraints (Like Filters)",
  "editor_content_sample_length": "Content sample length",
  "editor_result_counter": "Result count",
  "Version": "Version",
  "Email": "E-Mail",
  "date": "Date",
  "icon": "Icon",
  "client_appstrudlreport_feedbacktooshort": "The description of your request to our support team is too short.",
  "client_description": "Description",
  "Username": "Username",
  "client_settings": "Settings",
  "client_notifications": "Alerts",
  "client_edit_notifications": "Edit notification",
  "client_delete_notifications": "Remove notification",
  "edit_profile": "Edit profile",
  "GeneralSettings": "General Settings",
  "FrontendLanguage": "Language",
  "ResultsPerPage": "Results per page",
  "FilterSettings": "Filter Settings",
  "FilterLanguage": "Filter Language",
  "feedback_comment": "Comment",
  "feedback_end_message": "Thanks for your feedback!",
  "client_alert_edit": "Edit",
  "relevance_order": "Order in %",
  "group": "Group",
  "mes:hitinfo:rank": "Relevance",
  "mes:relevanceinfo.recency": "Recency",
  "mes:relevanceinfo.tf": "TF",
  "mes:relevanceinfo.tf_idf": "TFIDF",
  "mes:relevanceinfo.tf_izf_max": "TFIDF (Max Property)",
  "mes:relevanceinfo.proximity": "Proximity",
  "mes:relevanceinfo.percent_zone_boost": "Property Boost (%)",
  "mes:relevanceinfo.percent_term_boost": "Term Boost (%)",
  "mes:relevanceinfo.percent_document_boost": "Document Boost (%)",
  "mes:relevanceinfo.percent_term_match": "Terms (%)",
  "mes:relevanceinfo.percent_tf_idf": "TFIDF (%)",
  "relevanceInfo": "Relevance",
  "show_relevance_infos": "Show Relevance Infos",
  "client_email_alert_on_change": "Activate notifications",
  "client_alert_base": "Frequency of notifications",
  "client_alert_base_frequency": "Frequency",
  "client_alert_email": "E-mail address",
  "suggest_search_for": "Search for",
  "refineSearch": "Refine your search",
  "client_did_you_mean": "Did you mean",
  "search": "Search",
  "action_search": "Search",
  "reset_properties": "Reset properties",
  "preview": "Preview",
  "document-not-found": "Document not found.",
  "user": "User",
  "logout": "Logout",
  "login": "Login",
  "datasources": "Sources",
  "loading_more_results": "Loading more results ...",
  "mobileclient_load_more_results": "Load more results ",
  "Everything": "Everything",
  "Close": "Close",
  "custom_datasources": "Custom Sources",
  "custom_datasources_add": "Add Custom Source",
  "web_client_url": "Web Client URL",
  "people": "People",
  "videos": "Videos",
  "application": "Applications",
  "folders": "Folders",
  "rooms": "Rooms",
  "mails": "E-Mails",
  "please_enter_a_valid_url": "Please enter a valid URL.",
  "Collect": "Collect",
  "CollectWidgetTitle": "Collected Results",
  "Apply": "Apply",
  "daterangepicker_from": "From",
  "daterangepicker_to": "To",
  "daterangepicker_focus_the_calendar": "Use ALT+Down to focus the calendar",
  "daterangepicker_previous_month": "Previous Month",
  "daterangepicker_next_month": "Next Month",
  "daterangepicker_year": "Year",
  "daterangepicker_month": "Month",
  "daterangepicker_chose_date": "Choose Date",
  "daterangepicker_dialog_open_message": "Date range select dialog is now open - use tab to enter it.",
  "daterangepicker_from_date": "Choose from date, ",
  "daterangepicker_to_date": "Choose to date, ",
  "daterangepicker_placeholder": "Select a date range",
  "EmptyList": "Empty",
  "search_tabs": "Search Tabs",
  "alert_search_tab": "Search Tab",
  "active_filters": "Active Filters",
  "moments_ago": "Moments ago",
  "search_tab": "Search Tab {0}",
  "create_search_tab": "Create Search Tab",
  "error_checkout_collected_results": "Error calling \"{0}\".",
  "Exchange_mail": "Email",
  "editor_text_query": "Text Query",
  "editor_structural_query": "Structural Query",
  "editor_save_module": "Save",
  "editor_edit_module": "Edit Module",
  "editor_app_fragment_title": "Title",
  "editor_app_fragment_name": "Name",
  "editor_app_fragment_type": "Type",
  "editor_app_fragment_description": "Description",
  "editor_app_fragment_html": "HTML Snippet",
  "editor_app_fragment_schema": "Schema",
  "editor_save_module_as": "Save As",
  "editor_new": "New",
  "editor_edit_module_properties": "Edit",
  "editor_cancel": "Cancel",
  "editor_layout_title": "Layout",
  "editor_padding_right": "Date scale right (in month)",
  "editor_padding_left": "Date scale left (in month)",
  "editor_result_template_suggestlist_title": "Suggestlist",
  "add_new_alert": "Add New Alert",
  "editor_count_filtered_facet_values": "Display count for deselected filter values",
  "editor_chart_title": "Title",
  "editor_pie_title": "Pie chart",
  "editor_bar_title": "Bar chart",
  "editor_line_title": "Line chart",
  "editor_more": "More",
  "editor_searchcontainer": "Search Container",
  "editor_answer_box": "AI Answers",
  "editor_search-info": "Search Info",
  "editor_chatframe": "AI Chat (iframe)",
  "editor_ai_chat": "AI Chat",
  "editor_gen_ai": "GenAI",
  "editor_chat_constraint": "Retrieval Constraint",
  "editor_show_chat_model": "Show model",
  "editor_show_chat_conversation": "Show side navigation",
  "editor_chat_height": "Height",
  "editor_chat_full_view": "Maximum height",
  "editor_chat_third_view": "2/3 height",
  "editor_chat_half_view": "Half height",
  "editor_chat_quarter_view": "1/4 height",
  "editor_chat_automatic_view": "Automatic",
  "editor_chat_use_user_query": "Restrict to Search Input",
  "editor_chat_use_user_constraints": "Restrict to Filter Constraints",
  "editor_chat_use_source_context_constraints": "Restrict to Search Constraint",
  "chat_load_error_message": "The AI Chat is currently unavailable.",
  "editor_preview_title": "HTML and PDF Preview",
  "editor_preview_completehtml": "Preview of the complete HTML",
  "editor_preview_enable_pdfjs": "Enable PDF.js",
  "editor_preview_full_html": "Preview of the full HTML",
  "editor_search_name": "Search name",
  "editor_answer_request_properties": "Request properties from template",
  "editor_charts": "Charts",
  "editor_choose_chart": "Choose chart",
  "editor_chart_path": "Path",
  "editor_chart_width": "Width",
  "editor_chart_height": "Height",
  "editor_chart_source": "Source",
  "editor_chart_source_name": "Source name",
  "editor_title_align": "Title align",
  "editor_show_legend": "Show legend",
  "editor_chart_source_count": "Count of filters",
  "editor_use_custom_sourcename": "Use custom source name",
  "editor_suggest_before_submit_action": "Before Submit Action",
  "editor_custom_sourcename": "Custom Source Name",
  "alerting_dashboard": "Manage Alerts",
  "globalAlerts": "Templates",
  "userAlerts": "My Alerts",
  "client_add_notifications": "Create notification",
  "client_create_notification": "Add notification",
  "client_notification_update_notifications_template": "Update notification",
  "client_notification_subscribe_notifications_template": "Subscribe notification",
  "client_notification_share_notifications_template": "Share notification",
  "client_notification_update_abo_notifications_template": "Update subscription ",
  "client_notification_create_notifications_template": "Create Template",
  "client_notification_title": "Title",
  "client_notification_description": "Description",
  "client_notification_email": "E-Mail",
  "client_notification_user": "Username",
  "client_group_tag": "Group Tag",
  "editor_layout_columns": "{{number}} Columns",
  "editor_update": "Update",
  "editor_layout_sidebar_main": "Sidebar - Main",
  "editor_layout_main_sidebar": "Main - Sidebar",
  "editor_layout_header": "Header",
  "editor_queryfield_title": "Searchbox",
  "editor_queryfield_description": "Display a query input field.",
  "editor_breadcrumb_title": "Breadcrumb",
  "editor_breadcrumb_description": "Display a breadcrumb of the search restrictions used.",
  "editor_result_append_on_scroll": "Append results when scrolling",
  "editor_result_allow_symbolic_path": "Allow symbolic path",
  "editor_result_title": "Results",
  "suggest_search_results": "Results",
  "editor_singular_result_title": "Result",
  "editor_edit": "Edit {0}",
  "editor_result_group_searchsettings": "Search Settings",
  "editor_result_constraint": "Restrict the results",
  "editor_result_count": "Results",
  "editor_result_answers_count": "Answer Results",
  "copy_answer_to_clipboard": "Copy Answer to Clipboard",
  "curated_answer": "Curated answer",
  "curated_answer_title": "This answer has been curated by an administrator.",
  "answer_copied": "Answer copied",
  "related_answers": "Related answers",
  "editor_show_answers": "Show answers",
  "editor_result_min_similarity_score": "Minimum answer similarity score",
  "editor_result_template_list_title": "List",
  "editor_result_template_table_title": "Table",
  "editor_result_template_imagegallery_title": "Image Gallery",
  "editor_result_template_map_title": "Map",
  "editor_computed_properties": "Computed properties",
  "editor_aggregated_properties": "Aggregated Properties",
  "editor_summarize_by_property": "Summarize by Property",
  "editor_summarize_by_non_existent": "Group results without the selected property",
  "editor_result_template_template_label": "Template",
  "editor_pager_title": "Pager",
  "editor_pager_description": "Pager",
  "editor_facet_dropdownfilter": "Show as dropdownfilter",
  "editor_facet_closeOnFocusOut": "Automatically close dropdownfilter",
  "editor_facet_suggest_label": "Show suggestions?",
  "editor_facet_intersect_values": "Combine selected filter values using",
  "editor_facet_intersect_values_or": "OR",
  "editor_facet_intersect_values_and": "AND",
  "editor_remove_label": "Remove",
  "editor_remove_all_label": "Remove All",
  "editor_facet_include_all_descendants": "Include all descendants (inefficient)",
  "client_label_or": "or",
  "client_label_and": "and",
  "add_expression_label": "Add Expression",
  "duplicate_group_label": "Duplicate Group",
  "add_group_label": "Add Group",
  "between": "Between",
  "daterangepicker_between_tooltip": "A start date and an end date are required.",
  "daterangepicker_from_tooltip": "A start date is required.",
  "daterangepicker_to_tooltip": "An end date is required.",
  "editor_facet_disable_userinput": "Disable user input via suggest",
  "editor_suggest_timeout": "Suggest request timeout (sec.)",
  "editor_suggest_initial_source_id_order": "Initial source ID pattern order",
  "editor_suggest_source_id_order": "Source ID pattern order",
  "editor_suggest_default_tab_title": "Default tab title",
  "editor_facet_incomplete_class": "CSS class for incomplete filter results",
  "editor_facet_term_constraint_label": "Suggest term property alias",
  "editor_facet_user_input_label": "Show user input",
  "editor_facet_datepicker_placeholder": "Date range input placeholder",
  "editor_facet_datepicker_icon": "Icon for date range input",
  "editor_facet_user_input_value_auto": "Choose widget automatically",
  "editor_facet_user_input_value_enabled": "Use specific widget",
  "editor_facet_orderby_count": "Count",
  "editor_facet_orderby_predefined": "Custom",
  "editor_facet_user_input_value_disabled": "Disabled",
  "editor_facet_user_input_template_label": "Widget for user input",
  "editor_facet_user_input_template_value_suggest": "Auto complete",
  "editor_facet_user_input_template_value_inputdate": "Date picker",
  "editor_facet_always_visible_label": "Always show user input",
  "facet_suggest": "Search in {{{criteria}}}",
  "editor_facet_title": "Filter",
  "editor_facet_title_label": "Title",
  "search_by_filter_name": "Search by filter name",
  "search_by_module_name": "Search by module name",
  "editor_facet_displayed_label": "Number of displayed filter values",
  "editor_facet_and_available_label": "Allow combinations of filter values",
  "editor_facet_collapsible_label": "Collapsible",
  "editor_facet_hide_filter_options_label": "Hide filter options",
  "editor_facet_default_open_label": "open by default",
  "action_rename": "Rename",
  "action_delete": "Delete",
  "action_remove": "Remove",
  "article_button_cancel": "Cancel",
  "article_button_publish": "Save",
  "Save": "Save",
  "publish": "Publish",
  "section_editor_title": "Editor",
  "section_button_edit": "Edit",
  "error_on_paging": "on paging. Failed to get response.",
  "click_here_to_trigger_search": "Click here to trigger search again.",
  "editor_description_title": "Create Insight Apps using our Module Kit.",
  "editor_description_body": "Create Insight Apps using your information and embed them into your website in no time, without any programming skills.",
  "EXPORT_SUCCESS": "Success",
  "EXPORT_TIMEOUT": "Maximum Exports per Session exceeded.",
  "EXPORT_ERROR": "Error",
  "EXPORTS": "Exports",
  "EXPORT_CANCEL": "Canceled export",
  "error_login_failed_login_manualy": "Pop-ups blocked: Login for {0} failed, {1}click here{2} to login manually.",
  "error_login_failed": "Login failed",
  "editor_export_help_title": "Export your Insight App",
  "editor_table_enable_dumping": "Enable dumping",
  "getDump": "Download dump",
  "editor_export_help_body": "Use \"Export\" to embed your Insight App into your website.",
  "editor_export": "Export",
  "editor_clone": "Clone",
  "editor_generate_embedded_code": "Generate Embed Code",
  "export": "export",
  "currentExport": "Export",
  "csvExport": "CSV export",
  "results_exportSearch": "Export search results",
  "exportet_search_results": "Exported search results",
  "no_exports_available": "No exports available",
  "action_0": "Default action",
  "export_results": "Export results",
  "or": "or",
  "editor_restart": "Restart",
  "editor_restart_confirm": "Do you really want to restart. All your changes will be lost.",
  "editor_export_title": "Use your Insight App",
  "editor_export_help": "Copy and paste the code below straight into your website.",
  "vendor": "Vendor",
  "vendor_name": "<span lang=\"en\">Mindbreeze</span> <span lang=\"de\">GmbH</span>, Linz, <span lang=\"en\">Austria</span>",
  "invalidInput": "Fehlerhafte Eingabe",
  "suggest_tabs": "Search in Tabs",
  "suggest_change_tab_to": "Change tab to",
  "editor_suggest_property": "Suggest property",
  "editor_suggest_property_constraint": "Suggest constraint",
  "editor_suggest_count": "Number of suggestions",
  "editor_suggest_source": "Source",
  "editor_suggest_initial_source_id_pattern": "Initial source ID pattern",
  "editor_suggest_source_id_pattern": "Source ID pattern",
  "editor_suggest_source_document_property": "Property",
  "editor_suggest_source_query_term": "Query",
  "editor_suggest_source_concept": "Concept",
  "editor_suggest_service": "API URL",
  "editor_suggest_disabled": "Disabled",
  "editor_suggest_categoryGroup": "Use group",
  "editor_suggest_categoryInitialGroup": "Use Group On Initialize",
  "editor_suggest_show_onfocus": "Show suggest on focus",
  "header_filters": "Filters",
  "saved_searches": "Saved Searches",
  "saved_search": "Saved Search",
  "save_search": "Save Search",
  "save_search_hint": "Save your Search by clicking",
  "alert_activate_hint": "Add new alert by clicking",
  "profile": "Profile",
  "save_changes": "Save changes",
  "voting_leave_positive_reply": "Leave a positive Reply",
  "voting_leave_negative_reply": "Leave a negative Reply",
  "voting_leave_reply": "Leave a Reply",
  "voting_send": "Send",
  "show_more": "Show more",
  "show_less": "Show less",
  "show_less_filters": "Show less filters",
  "show_more_filters": "Show more filters",
  "suggest_no_suggestions": "No suggestions available.",
  "no_restriction": "No restriction",
  "not_available": "Not available",
  "suggest_title": "Title",
  "suggest_popular_searches": "Popular searches",
  "suggest_terms_and_words": "Terms & Words",
  "suggest_my_recent_searches": "My recent searches",
  "suggest_result_singular": "One suggestion available, use up and down arrow keys to navigate.",
  "suggest_result_plural": "{0} suggestions available, use up and down arrow keys to navigate.",
  "editor_table_exportFormat": "Exportformat CSV",
  "editor_table_exclude_properties": "Exclude properties from translation",
  "editor_table_allowEdit_label": "Editable table",
  "editor_table_properties": "Properties",
  "editor_table_allowExport": "Allow export",
  "editor_result_template_timeline_title": "Timeline",
  "editor_timeline_height": "Height (auto or eg. 200px)",
  "editor_timeline_date": "Property (eg. mes:date)",
  "editor_timeline_range_start": "Start date",
  "editor_timeline_range_end": "End date",
  "client_toolbar_groupby_label": "Group by",
  "client_groupby_none": "Ungrouped",
  "client_group_label": "Group",
  "info_mobile_safari_private_mode": "Private Browsing Mode: Limited functionality. Some settings cannot be saved, e.g. Search Tabs and Saved Searches. If you want to save these settings, disabled the Private Browsing Mode in your browser for Mindbreeze InSpire.",
  "info_local_storage_not_available": "Limited functionality: Some settings cannot be saved, e.g. Search Tabs and Saved Searches. If you want to save these settings, please use a browser that supports saving information or deactivate settings that prevent saving for Mindbreeze InSpire.",
  "info_header": "Info",
  "missing_query": "Please enter a query!",
  "editor_anchor_title": "Link",
  "editor_anchor_href_label": "Address",
  "actions": "Actions",
  "editor_anchor_text_label": "Text",
  "editor_anchor_open_search_generic_engine_title": "external search engine",
  "continue_search": "Search with {0}",
  "map_skip_down": "Top of map, skip to end.",
  "map_skip_up": "End of map, skip to top.",
  "sidebar": "Tool Pane",
  "topbar": "Top Bar",
  "federated_sources": "Federation",
  "results_shortcut_tooltip": "Back to result using {0}",
  "choose_from_options": "Select property",
  "feedback_send": "Send feedback",
  "result_rate": "Rate the result",
  "feedback_description": "Your message",
  "submit_feedback": "Submit feedback",
  "editor_pages": "Pages",
  "editor_pages_description": "Navigate results by pages",
  "editor_pages_max_page_count": "Number of pages",
  "general": "General",
  "client_name_already_taken": "Name is already taken, please choose another name.",
  "settings_search_personalized_results": "Personalized relevance for search results",
  "settings_search_is_on": "activated",
  "settings_search_is_off": "deactivated",
  "anonymous": "Not logged in",
  "giveFeedback": "",
  "confirm": "Confirm",
  "do_you_really_want_to_delete_the_app": "Do you really want to delete the app?",
  "editor_result_show_nonmatched_terms": "Show non matched terms",
  "editor_result_optional_terms_ratio": "Optional terms ratio",
  "result_missing_term": "Missing",
  "result_must_contain_term": "Must contain exactly",
  "client_copy_url": "Copy search link",
  "entity_person": "Person",
  "entity_location": "Location",
  "entity_organization": "Organization",
  "entity_misc": "Misc",
  "entity_date": "Date",
  "filter_by": "Filter by",
  "reset_filters": "Reset filters",
  "disabled": "Disabled",
  "hidden": "Hidden",
  "editor_reset_query_on_reset_label": "Clear Search Input on Filter Reset",
  "editor_behaviour_no_selected_filters": "Behaviour when No Filters Are Selected",
  "editor_resetfilters_no_selected_filter_behaviour_always_show": "Always Visible",
  "mmc_refresh": "Refresh",
  "mindbreeze_inSpire": "Mindbreeze InSpire",
  "insight_applications": "Insight Applications",
  "create_application": "Create Application",
  "use_your_insight_app": "Use your Insight App",
  "copy_paste_the_code": "Copy and paste the code below straight into your website.",
  "app_ID": "App-ID:",
  "snippet": "Snippet",
  "saving": "Saving",
  "reload": "Reload",
  "error_app_deletion": "Error: App could not be deleted!",
  "error_app_creation_or_deletion": "Error: App could not be created!",
  "error_app_loading": "Error: App could not be loaded!",
  "edit_in_designer": "Edit in Designer",
  "view_snippet": "View Snippet",
  "export_snippet": "Export Snippet",
  "no_frequency": "No frequency",
  "update_user": "Update user",
  "add_user": "Add user",
  "alertname": "Alertname",
  "view": "View",
  "ID": "ID",
  "Owner": "Owner",
  "displayname": "Displayname",
  "cron_expression": "Cron expression",
  "email_subscription": "Email Subscription",
  "query": "Query",
  "unparsed": "Unparsed",
  "constraints": "Constraints",
  "add_alert": "Add Alert",
  "create_alert": "Create Alert",
  "failed_to_trigger_observer": "Failed to trigger observer",
  "edit_user": "Edit user",
  "delete_user": "Delete user",
  "users": "Users",
  "alerts": "Alerts",
  "edit_alert": "Edit alert",
  "roles": "Roles",
  "upload_file": "Upload File",
  "you_need_more_free_space": "You need {{value}} MB more free space!",
  "inspire_system_loader": "InSpire System Loader",
  "upload_update": "Upload Update",
  "download_log": "Download Log",
  "please_choose_only_SFX_file": "Please choose only one SFX file",
  "error_protocol": "Error-Protocol",
  "choose_file": "Choose File",
  "no_file_chosen": "No file chosen",
  "mindbreeze_inpire_update_file": "Mindbreeze InSpire Update File",
  "choose_update_file": "Choose Update File:",
  "please_check_error_protocol": "Please check the Error-Protocol below.",
  "installing_inspire_system_manager": "Installing InSpire System Manager",
  "disc_space_not_sufficient_reload": "Your disc space is not sufficient. Please make sure that you have enough space on your hard disk.",
  "you_have_to_refresh_you_page": "Then you have to {{value}} your browser.",
  "update_wizard": "Update-Wizard",
  "force_update_recoverable_errors": "Force Update on Recoverable Verification Errors",
  "working": "Working",
  "start": "Start",
  "the_update_will_run": "The update will run now",
  "success": "Success",
  "check_protocol_below": "Check Protocol below.",
  "SSL_certificate": "SSL Certificate",
  "upload_mindbreeze_inSpire_certificate": "Upload Mindbreeze InSpire Certificate",
  "upload_certificate": "Upload Certificate",
  "certificate_installed": "Certificate installed",
  "error_see_protocol_for_details": "Error! See Protocol for details",
  "coose_certificate_file": "Choose Certificate File",
  "certificate_upload": "Certificate upload",
  "no_fiel_chosen": "No file chosen",
  "installing_certification": "Installing Certificate",
  "please_choose_only_one_certificate_file": "Please choose only one Certificate file",
  "mindbreeze_inSpire_global_settings": "Mindbreeze InSpire Global Settings",
  "global_settings": "Global Settings",
  "SMTP_server": "SMTP Server",
  "enter_SMTP_server_to_enable_email": "Enter SMTP Server to enable sending of Emails by Mindbreeze InSpire Services",
  "SMTP_default_server": "SMTP Default Sender",
  "enter_default_server_to_enable_email": "Enter default Sender for Emails sent by Mindbreeze InSpire Services",
  "restart": "Restart",
  "infrastructure": "Infrastructure",
  "stop": "Stop",
  "table_paginate_first": "First",
  "table_paginate_last": "Last",
  "table_paginate_next": "Next",
  "table_paginate_previous": "Previous",
  "table_empty": "No data available in table",
  "table_pagination_info": "Showing _START_ to _END_ of _TOTAL_ entries",
  "table_pagination_empty_info": "Showing 0 to 0 of 0 entries",
  "table_pagination_filtered_info": "(filtered from _MAX_ total entries)",
  "table_pagination_length_menu": "Show _MENU_ entries",
  "table_pagination_processing": "Processing...",
  "table_pagination_loading": "Loading...",
  "table_pagination_zero_records": "No matching records found.",
  "last_modified": "Last modified",
  "ask_anything": "Ask Anything",
  "editor_searchform_requires_user_input": "Requires User Input",
  "editor_searchform_auto_focus": "Auto-focus",
  "outlook_add_in_description": "The Mindbreeze Outlook Add-In provides the Mindbreeze InSpire Search functionality within Microsoft Outlook.",
  "outlook_add_in_install": "Install Microsoft Outlook Add-In",
  "client_360_degree_view_of": "360° View of {0}",
  "client_360_degree_close": "Close 360-Degree View",
  "client_360_degree_open": "Open 360-Degree View",
  "client_360_no_result_found": "No results found",
  "client_360_degree_show_all_results": "Show all results",
  "application_extension_options_json": "Application extension options (JSON)",
  "please_provide_a_valid_json_value": "A valid JSON value is needed",
  "stop_responding": "Stop responding",
  "additional_sources": "Additional sources",
  "select_model": "Select model",
  "regenerate_anwser": "Regenerate",
  "count_sources_found": "{0} sources found",
  "one_source_found": "One source found",
  "editor_generate_answer_from_ai": "Generate text from retrieved answers using GenAI",
  "mindbreeze_answer_generate_info": "This response was generated with assistance of Mindbreeze AI",
  "editor_template_system_instructions": "LLM Prompt instruction",
  "editor_prompt_system_instruction_for_no_answer": "LLM Prompt instruction, if no answers were found",
  "editor_advanced_prompt_configuration": "Advanced LLM Prompts",
  "editor_system_message_template": "LLM Prompt instruction with placeholder",
  "editor_prompt_system_instruction_with_placeholder_for_no_answer": "LLM Prompt instruction with placeholder, if no answers were found",
  "editor_user_message_template": "LLM Prompt user message with placeholder",
  "editor_prompt_user_instruction_with_placeholder_for_no_answer": "LLM Prompt user message with placeholders, if no answers were found",
  "editor_different_prompt_instructions_for_no_answer": "Use different instruction, if no answers were found",
  "editor_different_user_prompt_instructions_for_no_answer": "Use different user message, if no answers were found",
  "editor_answers_rerieved_context_source_answers_only": "Answers Only",
  "editor_answers_rerieved_context_source_answers_merge": "Answers and Results",
  "editor_answers_rerieved_context_source_answers_results_if_no_answer": "Results if no Answers",
  "editor_answers_rerieved_context_source_answers_results_only": "Results Only",
  "editor_answers_rerieved_context_source": "Retrieved Context Source",
  "editor_answers_rerieved_context_limit": "Retrieved Item Limit for Generation Context",
  "editor_use_custom_prompt": "Use custom prompt",
  "editor_pipeline_selection": "Pipeline selection",
  "editor_pipeline_selection_value": "Pipeline",
  "editor_use_insight_app_as_source_for_generation": "Use sources from Insight App for generation",
  "editor_answers_use_user_input": "Use Input",
  "editor_answers_use_user_search": "Restrict to Search Input",
  "editor_answers_use_user_constraints": "Restrict to Filter Constraints",
  "editor_answer_use_source_context_constraints": "Restrict to Search Constraint",
  "editor_parent_user_query_as_constraint": "Separate search input",
  "editor_initialize_from_parent_user_query": "Initialize search input from main search",
  "editor_pipeline_selection_by_id": "By ID",
  "editor_pipeline_selection_by_key": "By Key",
  "editor_clear_answer_on_change": "Immediate reset generated answers on user input",
  "editor_modules": "Modules",
  "editor_modelid": "Model ID",
  "editor_search_settings": "Settings",
  "editor_enter_collection_name": "Please enter the collection name",
  "editor_answer_metadatakeys": "Metadata Keys",
  "editor_answer_show_question": "Show Question",
  "editor_answer_citation_options": "Citation Options",
  "editor_answer_enable_citation": "Enable Citations",
  "editor_answer_line_limit": "Line Limit",
  "editor_answer_use_metadatakeys": "Use Metadata",
  "editor_chat_initialize_from_user_query": "Initial User Input from Search Query",
  "editor_chat_initial_user_input": "Initial User Input",
  "editor_chat_apply_answers_settings": "Apply Pipeline Selection and Presets from AI Answers Settings",
  "editor_chat_show_create_new_conversation": "Show New Chat Action",
  "create_new_conversation": "New Chat",
  "start_new_conversation": "Start new chat",
  "editor_searchform_search_as_you_type": "Search As You Type",
  "editor_searchform_search_as_you_type_timeout": "search-as-you-type Timeout",
  "editor_facet_multiselectable": "Allow Having Multiple Sections Open",
  "editor_facet_title_template_element_id": "Filter Title Element ID",
  "ai_answer_generic_error_message": "There was a problem generating a response.",
  "editor_facet_excluded_element_class": "Excluded class name",
  "modal_image_upload": "Image Upload",
  "modal_image_preview": "Image Preview",
  "modal_clickable_upload_hint": "Upload an Image",
  "modal_rest_upload_hint": "from Your Computer.",
  "modal_upload_preview_placeholder": "Preview of the selected image",
  "modal_upload_icon_placeholder": "Upload Icon",
  "generating_description_from_image": "Generating description from image",
  "failed_to_describe_image": "Failed to describe image!",
  "generating_app": "Generating app",
  "failed_to_generate_app": "Failed to generate app!",
  "parsing_query": "Parsing query",
  "refine_query": "Refine query",
  "use_insight_app": "Use Insight App",
  "loading_insight_app": "Loading Insight App...",
  "generated_config": "Generated config",
  "get_360_schema_for": "Get 360 Schema for",
  "welcome": "Welcome",
  "refine_query_failed_to_refine_query": "Refine query: Failed to refine query!",
  "got_constraint": "got constraint.",
  "show_for": "show for",
  "constraint": "Constraint"
};
});
